module.exports = __webpack_public_path__ + "img/advantage3.f246a6a6.svg";